import SecureLS from "secure-ls";
class TokenService {
  public sls: SecureLS;

  constructor() {
    this.sls = new SecureLS({ encodingType: "aes" });
    this.sls.set("secreteKey", "mySecreteKEY");
  }

  getLocalRefreshToken() {
    //const authTokens = JSON.parse(localStorage.getItem('authTokens')!);
    const authTokens = this.sls.get("authTokens")
      ? JSON.parse(this.sls.get("authTokens"))
      : "";
    return authTokens?.refresh;
  }

  getLocalAccessToken() {
    //const authTokens = JSON.parse(localStorage.getItem('authTokens')!);
    const authTokens = this.sls.get("authTokens")
      ? JSON.parse(this.sls.get("authTokens"))
      : "";
    return authTokens?.access;
  }

  updateLocalAccessToken(token: string) {
    //let authTokens = JSON.parse(localStorage.getItem("authTokens")!);
    let authTokens = this.sls.get("authTokens")
      ? JSON.parse(this.sls.get("authTokens"))
      : {};
    authTokens.access = token;
    //localStorage.setItem("authTokens", JSON.stringify(authTokens));
    this.sls.set("authTokens", JSON.stringify(authTokens));
  }

  saveLocalAccessToken(token: string) {
    //localStorage.setItem("authTokens", JSON.stringify(token));
    this.sls.set("authTokens", JSON.stringify(token));
  }

  saveEmloyeeSettings(data: string) {
    this.sls.set("employeeSettings", JSON.stringify(data));
  }

  getTokenUserRole() {
    //const authTokens = JSON.parse(localStorage.getItem('authTokens')!);
    const authTokens = this.sls.get("authTokens")
      ? JSON.parse(this.sls.get("authTokens"))
      : "";
    if (authTokens.data.is_superuser) return "ADMIN";
    else if (authTokens.data.is_staff) return "STAFF";
    else return "USER";
  }

  getTokenUser() {
    //const authTokens = JSON.parse(localStorage.getItem('authTokens')!);
    const authTokens = this.sls.get("authTokens")
      ? JSON.parse(this.sls.get("authTokens"))
      : "";
    return authTokens?.data;
  }

  getEmployeePrefixSetting() {
    //const settings = JSON.parse(localStorage.getItem('employeeSettings')!);
    const settings = this.sls.get("employeeSettings")
      ? JSON.parse(this.sls.get("employeeSettings"))
      : "";
    const sett = settings ? JSON.parse(settings) : "";
    return sett?.employee_prefix;
  }

  clear() {
    this.sls.removeAll();
  }
}

export function checkStringFormat(inputString: string) {
  try {
    const parsedObject = JSON.parse(inputString);
    if (typeof parsedObject === "object" && parsedObject !== null) {
      return "json_object";
    }
  } catch (error) {
    // Parsing as JSON failed, treat it as a plain string
  }

  return "plain_string";
}

export default new TokenService();
